import { render, staticRenderFns } from "./DoubtFormComponent.vue?vue&type=template&id=77d1f87c"
import script from "./DoubtFormComponent.vue?vue&type=script&lang=js"
export * from "./DoubtFormComponent.vue?vue&type=script&lang=js"
import style0 from "./DoubtFormComponent.vue?vue&type=style&index=0&id=77d1f87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports